<template>
	<div class="container_head ">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="card" v-for="(item,index) in list" :key="index" @click="goxq(item.id)">
					<div class="top">
						<img width="100%" :src="imgIp+item.photo||defaultimg" alt="" style="width: 100%;height: 120px;object-fit: contain;">
						<!-- i'http://192.168.223.62:8089'+item.photo||defaultimg-->
					</div>
					<div class="down">
						<div class="title">{{item.name}}</div>
						<!-- <div class="desc yh">成员身份：{{item.memberType}}</div> -->
						<div class="desc">
							所在小区：
							<!-- <img width="10px" src="../../assets/yzjc/dh.png" alt=""> -->
							{{item.communityName}}
						</div>
						<div class="desc yh">楼宇信息：{{item.loudong}}-{{item.danyuan}}-{{item.louceng}}-{{item.mengpai}}</div>
						<div class="desc yh">联系电话：{{item.phone}}</div>
						<div class="desc yh">是否党员：{{item.partyMember}}</div>
						<!-- <div class="desc"><img width="10px" src="../../assets/yzjc/add.png" alt=""></div> -->
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		List
	} from 'vant';
	Vue.use(List);
	export default {
		data() {
			return {
				value: '',
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
				defaultimg: require('../../assets/yzjc/wyh.png')
			};
		},
		computed: {},
		mounted() {},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					this.pageNum=0;
					// 清空列表数据
					this.list = [];
					this.refreshing = false;
				}
				this.$axios.get('/api/v1/wechat/yzjc/yzwyh', {
					params: {
						pageNum: this.pageNum,
						pageSize: 15
					}
				}).then(res => {
					this.list.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
			goxq(id) {
				/* this.$router.push({
					path: "/yzjc/wyhdet",
					query: {
						id
					}
				}); */
			},
		}
	};
</script>

<style lang="less" scoped>
	.list {
		padding: 10px;
	}

	.card {
		padding: 6px;
		background-color: #fff;
		// border: 1px dashed #0eb6f5;
		overflow: hidden;
		width: 48%;
		height: 230px;
		float: left;
		margin: 1%;
		border-radius: 10px;

		.top {
			height: 120px;
		}

		.down {
			font-size: 12px;
			color: #999999;
			height: calc(100% - 120px);
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			.title {
				font-size: 14px;
				overflow:hidden; 
				text-overflow:ellipsis;
				display:-webkit-box; 
				-webkit-box-orient:vertical;
				-webkit-line-clamp:2;
				color: #333333;
			}
			.yh{
				overflow:hidden; 
				text-overflow:ellipsis;
				display:-webkit-box; 
				-webkit-box-orient:vertical;
				-webkit-line-clamp:1;
			}
			.desc {
				overflow:hidden; 
				text-overflow:ellipsis;
				display:-webkit-box; 
				-webkit-box-orient:vertical;
				-webkit-line-clamp:2;
				img {
					margin-right: 5px;
				}
			}
		}
	}
</style>
